module.exports = __webpack_public_path__ + "img/wechat-scode.5877b84a.png";